import { render, staticRenderFns } from "./how-it-works.vue?vue&type=template&id=6d8d9226&"
import script from "./how-it-works.vue?vue&type=script&lang=ts&"
export * from "./how-it-works.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports